export const exportToCSV = (data, filename = 'consent-data.csv') => {
  const headers = [
    'Consent Date', 
    'First Name',
    'Last Name',
    'Email',
    'Mobile',
    'Expiry Date',
    'Withdrawn Date',
    'Remarks',
  ];

  const rows = data.map(item => [
    item.consent_date ? new Date(item.consent_date).toLocaleString() : '',
    item.first_name || '',
    item.last_name || '',
    item.email_id || '',
    item.mobile_number || '',
    item.expiry_date ? new Date(item.expiry_date).toLocaleDateString() : '',
    item.consent_withdrawn_date ? new Date(item.consent_withdrawn_date).toLocaleString() : '',
    item.remarks || '',
  ]);

  const csvContent = [headers, ...rows]
    .map(row => row.map(field => `"${field}"`).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportMarketingConsentToCSV = (data, filename = 'marketing-consent-data.csv') => {
  const headers = [
    'Consent Date',
    'First Name',
    'Last Name',
    'Email',
    'Mobile',
    'Expiry Date',
    'Rec Information',
    'Withdrawn Date',
    'Remarks',
  ];

  const rows = data.map(item => [
    item.consent_date ? new Date(item.consent_date).toLocaleString() : '',
    item.first_name || '',
    item.last_name || '',
    item.email_id || '',
    item.mobile_number || '',
    item.expiry_date ? new Date(item.expiry_date).toLocaleDateString() : '',
    item.marketing_opt_in ? 'Yes' : 'No',
    item.consent_withdrawn_date ? new Date(item.consent_withdrawn_date).toLocaleString() : '',
    item.remarks || '',
  ]);

  const csvContent = [headers, ...rows]
    .map(row => row.map(field => `"${field}"`).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportCreditNotesToCSV = (data, filename = 'credit-notes.csv') => {
  const headers = [
    'Guest ID',
    'Reservation ID',
    'Promo Name/Ref Code',
    'Trigger Date',
    'Amount',
    'Applied',
  ];

  const rows = data.map(item => [
    item.transaction?.guestId || '',
    item.transaction?.reservationId || '',
    item.promotion?.name || (item.referral_code ? `Referral: ${item.referral_code.code || item.referral_code}` : ''),
    item.triggerDate ? new Date(item.triggerDate).toLocaleDateString() : '',
    item.amount ? `A$${item.amount.toFixed(2)}` : '',
    item.applied ? 'Yes' : 'No',
  ]);

  const csvContent = [headers, ...rows]
    .map(row => row.map(field => `"${field}"`).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


